import { render, staticRenderFns } from "./CucinaPics.vue?vue&type=template&id=3131b1ff&"
import script from "./CucinaPics.vue?vue&type=script&lang=js&"
export * from "./CucinaPics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports